/**
 * Hub centralisé — monte toutes les modales / sidepanels d'action client.
 *
 * Usage :
 *   <ClientActionsProvider>
 *     <ClientEngagementTab />
 *     <ClientActionsHub />
 *   </ClientActionsProvider>
 */
import React from 'react';
import ClientDetailModal from './ClientDetailModal';
import RelancerClientModal from './RelancerClientModal';
import MessageModal from './MessageModal';
import CallModal from './CallModal';
import EmailModal from './EmailModal';
import TaskModal from './TaskModal';
import NoteModal from './NoteModal';
import RecommendedActionModal from './RecommendedActionModal';
import QuickContactPanel from './QuickContactPanel';

export default function ClientActionsHub() {
  return (
    <>
      <ClientDetailModal />
      <RelancerClientModal />
      <MessageModal />
      <CallModal />
      <EmailModal />
      <TaskModal />
      <NoteModal />
      <RecommendedActionModal />
      <QuickContactPanel />
    </>
  );
}
